import { axios } from '@Root/API'

export const edit = (studyProgrammeId, studyLocationId, payload)  => {
	return axios.post(`course-session/${studyProgrammeId}/student-financial-support/${studyLocationId}`, payload)
}
